// NOTE: Copied from workbench-icons based on guidance from design-systems
// because there was a problem with server side rendering and using these icons.
const Heart = () => (
  <svg viewBox="0 0 16 16" width="1em" fill="currentColor">
    <path d="M6.929 2.85c-1.584-1.508-3.657-1.445-5.24.064-2.833 2.7-.116 7.53 3.063 9.854 1.518 1.11 2.965 1.84 3.243 1.84.28 0 1.747-.734 3.28-1.848 3.187-2.314 5.86-7.147 3.027-9.846-1.583-1.51-3.647-1.572-5.23-.063-.054.051-1.077 1.069-1.077 1.069s-.992-.998-1.066-1.07z" />
  </svg>
);

export default Heart;
